/* eslint-disable no-template-curly-in-string */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Bullets from '../../../../../components/Bullets/Bullets';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import { CustomButton } from '../../../../../components/CustomButton';
import CustomCheckbox from '../../../../../components/CustomCheckbox/CustomCheckbox';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import { HelpButton } from '../../../../../components/HelpButton';
import ArrowBackIcon from '../../../../../components/Icons/ArrowBackIcon';
import ArrowForwardIcon from '../../../../../components/Icons/ArrowForwardIcon';
import NewAutoCompleteField from '../../../../../components/NewAutoCompleteField/NewAutoCompleteField';
import { Row } from '../../../../../components/Row';
import { changeContratoAssessorEditingValue } from '../../../../../store/modules/ContratosAssessoresActions';
import {
  clearEmpresaByCPFAssessor,
  loadAllEmpresas,
  loadEmpresaByCnpjComAcessoresNecessarios,
} from '../../../../../store/modules/EmpresasActions';
import { getFormattedCNPJ } from '../../../../../utils/DataFormatUtils';
import { getPropsToLabel } from '../../../../../utils/HelpButtonUtils';
import { getElementID } from '../../../../../utils/HTMLUtils';
import {
  allIsTrue,
  requiredIsValid,
  valorHoraIsValid,
} from '../../../../../utils/ValidationUtils';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import styles from './DadosAssessor.scss';
import GenericDados from './GenericDados';
import CustomCurrencyFieldValores from 'components/CustomCurrencyField/CustomCurrencyFieldValores';
import { InputAutomacaoNumber } from 'components/InputAutomacaoNumber/InputAutomacaoNumber';

const rootClassName = styles.rootClassName;
const rootElementId = 'contrato-dados-assessor';

const INITIAL_STATE = {
  cpfAssessorChanged: false,
  idEmpresaChanged: false,
  valorAssessoriaChanged: false,
  valorFormacaoChanged: false,
  valorOutrosChanged: false,
  valorReuniaoChanged: false,
  empresaByCnpjChanged: false,
};

class DadosAssessor extends GenericDados {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
      empresaByCnpj: null,
      assessoresByEmpresa: [],
    };
  }

  getActions = () => {
    return (
      <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-left'}
        >
          <CustomButton
            id='previous-button'
            label={this.props.languageValues.anterior}
            theme='pufvYellow'
            onClick={this.toPrevContent}
            leftIcon={<ArrowBackIcon />}
          />
        </Col>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-right'}
        >
          <CustomButton
            id='next-button'
            label={this.props.languageValues.proxima}
            theme='pufvYellow'
            onClick={() => {
              if (this.formIsValid()) {
                this.toSubmit(1, {
                  ...this.props.contratosAssessores.contratoEditing,
                });
              }
            }}
            rightIcon={<ArrowForwardIcon />}
            disabled={this.submitButtonIsDisabled()}
          />
        </Col>
      </Row>
    );
  };

  submitButtonIsDisabled = () => {
    if (this.hasPermissions()) {
      return this.props.loading || !this.formIsValid();
    }
    return false;
  };

  fieldDisabled() {
    if (!this.hasPermissions()) {
      return true;
    }
    const editing = this.editing();
    if (editing) {
      if (!this.props.auth.userPermissions.contratos.assessor.edit) {
        return true;
      }
    }
    return this.props.loading;
  }

  reset() {
    this.setState(INITIAL_STATE);
  }

  componentWillUnmount() {
    this.reset();
  }

  UNSAFE_componentWillMount() {
    this.props.loadAllEmpresas();
  }

  cpfAssessorIsValid = () => {
    if (this.isEmpresaFieldNull()) {
      return true;
    }
    return !this.isEmpresaFieldNull() &&
      this.props.contratosAssessores.contratoEditing.cpfAssessores.length > 0
      ? {
        status: true,
      }
      : {
        status: false,
        error: this.props.languageValues.validations.assessor.required,
      };
  };

  idEmpresaIsValid = () => {
    if (this.props.contratosAssessores.contratoEditing.idEmpresa > 0) {
      return {
        status: true,
      };
    }
    return {
      status: false,
      error:
        this.state.empresaByCnpj !== null
          ? this.props.languageValues.validations.empresaAssessor.validation
          : this.props.languageValues.validations.empresaAssessor.required,
    };
  };

  valorHoraIsValid = (
    enabled,
    valorHora,
    requiredMessageError,
    validationMessageError
  ) => {
    if (enabled) {
      const required = requiredIsValid(valorHora, requiredMessageError);
      const validation = valorHoraIsValid(valorHora, validationMessageError);
      if (!required.status) {
        return required;
      }
      if (!validation.status) {
        return validation;
      }
    }
    return {
      status: true,
    };
  };

  valorAssessoriaIsValid = () => {
    return this.valorHoraIsValid(
      this.props.contratosAssessores.contratoEditing.valorAssessoriaEnabled,
      this.props.contratosAssessores.contratoEditing.valorAssessoria,
      this.props.languageValues.validations.valorAssessoria.required,
      this.props.languageValues.validations.valorAssessoria.validation
    );
  };

  valorFormacaoIsValid = () => {
    return this.valorHoraIsValid(
      this.props.contratosAssessores.contratoEditing.valorFormacaoEnabled,
      this.props.contratosAssessores.contratoEditing.valorFormacao,
      this.props.languageValues.validations.valorFormacao.required,
      this.props.languageValues.validations.valorFormacao.validation
    );
  };

  valorOutrosIsValid = () => {
    return this.valorHoraIsValid(
      this.props.contratosAssessores.contratoEditing.valorOutrosEnabled,
      this.props.contratosAssessores.contratoEditing.valorOutros,
      this.props.languageValues.validations.valorOutros.required,
      this.props.languageValues.validations.valorOutros.validation
    );
  };

  valorReuniaoIsValid = () => {
    return this.valorHoraIsValid(
      this.props.contratosAssessores.contratoEditing.valorReuniaoEnabled,
      this.props.contratosAssessores.contratoEditing.valorReuniao,
      this.props.languageValues.validations.valorReuniao.required,
      this.props.languageValues.validations.valorReuniao.validation
    );
  };

  getEmpresaId = () => {
    if (this.props.empresas.loadingEmpresaByCPFAssessor) {
      return this.props.languageValues.loadingEmpresa;
    }
    if (this.cpfAssessorIsValid().status) {
      return this.props.empresas.empresaByCPFAssessor.nome;
    }
    return '';
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      (newProps.loading !== this.props.loading && !newProps.loading) ||
      (!newProps.loading &&
        newProps.contratosAssessores.contratoEditing.cpfAssessor !==
        this.props.contratosAssessores.contratoEditing.cpfAssessor)
    ) {
      this.props.clearEmpresaByCPFAssessor();
    }
    if (
      !newProps.contratosAssessores.contratoEditing.valorAssessoriaEnabled &&
      newProps.contratosAssessores.contratoEditing.valorAssessoriaEnabled !==
      this.props.contratosAssessores.contratoEditing.valorAssessoriaEnabled
    ) {
      this.setValue(
        {
          target: {
            name: 'valorAssessoria',
            value: 0,
          },
        },
        () => this.setState({ valorAssessoriaChanged: false })
      );
    }
    if (
      !newProps.contratosAssessores.contratoEditing.valorFormacaoEnabled &&
      newProps.contratosAssessores.contratoEditing.valorFormacaoEnabled !==
      this.props.contratosAssessores.contratoEditing.valorFormacaoEnabled
    ) {
      this.setValue(
        {
          target: {
            name: 'valorFormacao',
            value: 0,
          },
        },
        () => this.setState({ valorFormacaoChanged: false })
      );
    }
    if (
      !newProps.contratosAssessores.contratoEditing.valorOutrosEnabled &&
      newProps.contratosAssessores.contratoEditing.valorOutrosEnabled !==
      this.props.contratosAssessores.contratoEditing.valorOutrosEnabled
    ) {
      this.setValue(
        {
          target: {
            name: 'valorOutros',
            value: 0,
          },
        },
        () => this.setState({ valorOutrosChanged: false })
      );
    }
    if (
      !newProps.contratosAssessores.contratoEditing.valorReuniaoEnabled &&
      newProps.contratosAssessores.contratoEditing.valorReuniaoEnabled !==
      this.props.contratosAssessores.contratoEditing.valorReuniaoEnabled
    ) {
      this.setValue(
        {
          target: {
            name: 'valorReuniao',
            value: 0,
          },
        },
        () => this.setState({ valorReuniaoChanged: false })
      );
    }
  }

  onCPFAssessorChanged = () => {
    if (!this.cpfAssessorIsValid().status) {
      this.setValue({
        target: {
          name: 'idEmpresa',
          value: -1,
        },
      });
    }
  };

  formIsValid() {
    const arr = [
      this.cpfAssessorIsValid().status,
      this.idEmpresaIsValid().status,
      this.valorAssessoriaIsValid().status,
      this.valorFormacaoIsValid().status,
      this.valorOutrosIsValid().status,
      this.valorReuniaoIsValid().status,
    ];
    return allIsTrue(arr);
  }

  getValorHoraLabel = (tipo) => {
    return this.props.languageValues.cadastroContratoValorHoraOf
      .split('${1}')
      .join(tipo);
  };

  getGenericCardScreenProps = () => {
    return {
      GenericCardProps: {
        className: rootClassName,
        title: (
          <CardTitle onClick={this.openStepsMenu}>
            {this.props.languageValues.cadastroContratoDadosAssessor}
          </CardTitle>
        ),
        actions: this.getActions(),
        bottomContent: (
          <Bullets
            total={this.props.totalBullets}
            selectedIndex={this.props.bulletsIndex}
          />
        ),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending:
          this.props.loading || this.props.empresas.loadingEmpresaByCPFAssessor,
      },
    };
  };

  isEmpresaFieldNull = () => {
    const idEmpresa = this.props.contratosAssessores.contratoEditing.idEmpresa;
    if (!idEmpresa || idEmpresa === '') {
      return true;
    } else {
      return false;
    }
  };

  handleValorAutomacaoChange = (campo, valor) => {
    this.setState({ [campo]: valor });
    this.props.changeContratoAssessorEditingValue(campo, valor);
  };

  render() {
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            if (this.formIsValid()) {
              this.toSubmit(1, this.props.contratosAssessores.contratoEditing);
            }
          }}
        >
          <button
            type='submit'
            className='hidden-button'
            disabled={this.submitButtonIsDisabled()}
          ></button>
          <Row>
            <Col cols={[12, 12, 6, 6, 6]}>
              <NewAutoCompleteField
                id={getElementID(rootElementId, 'empresa')}
                label={
                  <>
                    {this.props.languageValues.cadastroContratoEmpresa}
                    <HelpButton
                      text={
                        this.props.languageValues.cadastroContratoHintEmpresa
                      }
                      {...getPropsToLabel()}
                    />
                  </>
                }
                options={this.props.empresas.allList.map((item) => {
                  return {
                    label: `${getFormattedCNPJ(item.cnpjEmpresa)} - ${item.nome
                      }`,
                    value: item.id,
                    cnpj: item.cnpjEmpresa,
                  };
                })}
                value={this.props.contratosAssessores.contratoEditing.idEmpresa}
                onChange={(value) => {
                  let currValue = value && value.value !== '' ? value : '';
                  this.setValue(
                    {
                      target: {
                        name: 'idEmpresa',
                        value: currValue.value,
                      },
                    },
                    () => {
                      this.setValue(
                        {
                          target: {
                            name: 'cnpjEmpresa',
                            value: currValue.cnpj,
                          },
                        },
                        () => {
                          this.setValue(
                            {
                              target: {
                                name: 'cpfAssessores',
                                value: [],
                              },
                            },
                            () => {
                              this.setState({
                                empresaByCnpj: currValue.cnpj,
                                empresaByCnpjChanged: true,
                              });
                            }
                          );
                        }
                      );
                    }
                  );
                  if (value) {
                    this.props.loadEmpresaByCnpjComAcessoresNecessarios(
                      value.cnpj,
                      this.props.contratosAssessores.contratoEditing.cpfAssessores
                    );
                  } else {
                    this.setValue(
                      {
                        target: {
                          name: 'idEmpresa',
                          value: '',
                        },
                      },
                      () => {
                        this.setValue({
                          target: {
                            name: 'cpfAssessores',
                            value: [],
                          },
                        });
                      }
                    );
                  }
                }}
                loading={this.props.empresas.loadingAllList}
                loadingMessage={this.props.languageValues.loadingAssessores}
                error={!this.idEmpresaIsValid().status}
                helperText={
                  !this.idEmpresaIsValid().status
                    ? this.props.languageValues.empresaRequired
                    : ''
                }
                disabled={
                  this.fieldDisabled() ||
                  this.disabledWhenDistrato() ||
                  this.disabledWhenAditivo() ||
                  this.disabledWhenDistrato() ||
                  this.props.empresas.loadingAllList
                }
              />
            </Col>
            <Col cols={[12, 12, 6, 6, 6]}>
              <NewAutoCompleteField
                id={getElementID(rootElementId, 'assessor')}
                label={this.props.languageValues.cadastroContratoAssessor}
                placeholder={
                  this.props.empresas.loadingAllList ||
                    this.props.empresas.loadingEmpresaByCnpjAssessoresNecessarios
                    ? this.props.languageValues.loadingAssessores
                    : ''
                }
                options={(this.props.empresas.empresaByCnpjAssessoresNecessarios
                  .assessores
                  ? this.props.empresas.empresaByCnpjAssessoresNecessarios
                    .assessores
                  : []
                )
                  .filter((it) =>
                    it.codCoop.includes(
                      this.props.contratosAssessores.contratoEditing.codCoop
                    )
                  )
                  .map((item) => {
                    return {
                      label: item.nome,
                      value: item.cpf,
                    };
                  })}
                multiple
                value={
                  this.props.contratosAssessores.contratoEditing.cpfAssessores
                }
                onChange={(value) => {
                  const currValue =
                    value && value.length > 0
                      ? value.map((it) => it.value)
                      : [];
                  if (currValue) {
                    this.setValue(
                      {
                        target: {
                          name: 'cpfAssessores',
                          value: currValue,
                        },
                      },
                      this.onCodCoopChanged
                    );
                    this.setState({
                      cpfAssessorChanged: true,
                    });
                  } else {
                    this.setState(
                      {
                        assessoresByEmpresa: [],
                      },
                      this.onCPFAssessorChanged
                    );
                  }
                }}
                loading={
                  this.props.empresas.loadingAllList ||
                  this.props.empresas.loadingEmpresaByCnpjAssessoresNecessarios
                }
                loadingMessage={this.props.languageValues.loadingAssessores}
                error={
                  !this.isEmpresaFieldNull().status &&
                  this.state.cpfAssessorChanged &&
                  !this.cpfAssessorIsValid().status
                }
                helperText={
                  !this.isEmpresaFieldNull().status &&
                    this.state.cpfAssessorChanged &&
                    !this.cpfAssessorIsValid().status
                    ? this.cpfAssessorIsValid().error
                    : ''
                }
                disabled={
                  this.isEmpresaFieldNull().status ||
                  !this.idEmpresaIsValid().status ||
                  this.fieldDisabled() ||
                  this.disabledWhenDistrato() ||
                  this.disabledWhenAditivo() ||
                  this.props.empresas.loadingAllList ||
                  this.props.empresas.loadingEmpresaByCnpjAssessoresNecessarios
                }
              />
            </Col>
          </Row>
          {this.disabledWhenDistrato() ? null : (
            <>
              <Row>
                <Col
                  cols={[12, 12, 6, 6, 6]}
                  className={rootClassName + '-valor-hora-col'}
                >
                  <div className={rootClassName + '-checkbox-valor-hora'}>
                    <CustomCheckbox
                      id={getElementID(
                        rootElementId,
                        'checkbox-valor-hora-assessoria'
                      )}
                      label={''}
                      name='valorAssessoriaEnabled'
                      onChange={this.setValue}
                      checked={
                        this.props.contratosAssessores.contratoEditing
                          .valorAssessoriaEnabled
                      }
                      disabled={this.fieldDisabled()}
                    />
                  </div>
                  <div className={rootClassName + '-textfield-valor-hora'}>
                    <CustomCurrencyFieldValores
                      id={getElementID(rootElementId, 'valor-hora-assessoria')}
                      label={this.getValorHoraLabel(
                        this.props.languageValues
                          .agendaAssessorPedagogicoAssessoriaType
                      )}
                      name='valorAssessoria'
                      value={
                        this.props.contratosAssessores.contratoEditing
                          .valorAssessoria
                      }
                      onChange={(value) => {
                        this.setValue({
                          target: {
                            name: 'valorAssessoria',
                            value: value,
                          },
                        });
                      }}
                      error={
                        this.state.valorAssessoriaChanged &&
                        !this.valorAssessoriaIsValid().status
                      }
                      helperText={
                        this.state.valorAssessoriaChanged &&
                          !this.valorAssessoriaIsValid().status
                          ? this.valorAssessoriaIsValid().error
                          : ''
                      }
                      disabled={
                        this.fieldDisabled() ||
                        !this.props.contratosAssessores.contratoEditing
                          .valorAssessoriaEnabled
                      }
                    />
                    <InputAutomacaoNumber
                      id='valorAssessoriaCentralizado'
                      valorAutomacao={this.state.valorAssessoria}
                      onValorAutomacaoChange={(valor) =>
                        this.handleValorAutomacaoChange(
                          'valorAssessoria',
                          valor
                        )
                      }
                    />
                  </div>
                </Col>
                <Col
                  cols={[12, 12, 6, 6, 6]}
                  className={rootClassName + '-valor-hora-col'}
                >
                  <div className={rootClassName + '-checkbox-valor-hora'}>
                    <CustomCheckbox
                      id={getElementID(
                        rootElementId,
                        'checkbox-valor-hora-formacao'
                      )}
                      label={''}
                      name='valorFormacaoEnabled'
                      onChange={this.setValue}
                      checked={
                        this.props.contratosAssessores.contratoEditing
                          .valorFormacaoEnabled
                      }
                      disabled={this.fieldDisabled()}
                    />
                  </div>
                  <div className={rootClassName + '-textfield-valor-hora'}>
                    <CustomCurrencyFieldValores
                      id={getElementID(rootElementId, 'valor-hora-formacao')}
                      label={this.getValorHoraLabel(
                        this.props.languageValues
                          .agendaAssessorPedagogicoFormacaoType
                      )}
                      name='valorFormacao'
                      value={
                        this.props.contratosAssessores.contratoEditing
                          .valorFormacao
                      }
                      onChange={(value) => {
                        this.setValue({
                          target: {
                            name: 'valorFormacao',
                            value: value,
                          },
                        });
                      }}
                      error={
                        this.state.valorFormacaoChanged &&
                        !this.valorFormacaoIsValid().status
                      }
                      helperText={
                        this.state.valorFormacaoChanged &&
                          !this.valorFormacaoIsValid().status
                          ? this.valorFormacaoIsValid().error
                          : ''
                      }
                      disabled={
                        this.fieldDisabled() ||
                        !this.props.contratosAssessores.contratoEditing
                          .valorFormacaoEnabled
                      }
                    />
                    <InputAutomacaoNumber
                      id='valorFormacaoCentralizado'
                      valorAutomacao={this.state.valorFormacao}
                      onValorAutomacaoChange={(valor) =>
                        this.handleValorAutomacaoChange('valorFormacao', valor)
                      }
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col
                  cols={[12, 12, 6, 6, 6]}
                  className={rootClassName + '-valor-hora-col'}
                >
                  <div className={rootClassName + '-checkbox-valor-hora'}>
                    <CustomCheckbox
                      id={getElementID(
                        rootElementId,
                        'checkbox-valor-hora-outros'
                      )}
                      label={''}
                      name='valorOutrosEnabled'
                      onChange={this.setValue}
                      checked={
                        this.props.contratosAssessores.contratoEditing
                          .valorOutrosEnabled
                      }
                      disabled={this.fieldDisabled()}
                    />
                  </div>
                  <div className={rootClassName + '-textfield-valor-hora'}>
                    <CustomCurrencyFieldValores
                      id={getElementID(rootElementId, 'valor-hora-outros')}
                      label={this.getValorHoraLabel(
                        this.props.languageValues
                          .agendaAssessorPedagogicoOutrosType
                      )}
                      name='valorOutros'
                      value={
                        this.props.contratosAssessores.contratoEditing
                          .valorOutros
                      }
                      onChange={(value) => {
                        this.setValue({
                          target: {
                            name: 'valorOutros',
                            value: value,
                          },
                        });
                      }}
                      error={
                        this.state.valorOutrosChanged &&
                        !this.valorOutrosIsValid().status
                      }
                      helperText={
                        this.state.valorOutrosChanged &&
                          !this.valorOutrosIsValid().status
                          ? this.valorOutrosIsValid().error
                          : ''
                      }
                      disabled={
                        this.fieldDisabled() ||
                        !this.props.contratosAssessores.contratoEditing
                          .valorOutrosEnabled
                      }
                    />
                    <InputAutomacaoNumber
                      id='valorOutrosCentralizado'
                      valorAutomacao={this.state.valorOutros}
                      onValorAutomacaoChange={(valor) =>
                        this.handleValorAutomacaoChange('valorOutros', valor)
                      }
                    />
                  </div>
                </Col>
                <Col
                  cols={[12, 12, 6, 6, 6]}
                  className={rootClassName + '-valor-hora-col'}
                >
                  <div className={rootClassName + '-checkbox-valor-hora'}>
                    <CustomCheckbox
                      id={getElementID(
                        rootElementId,
                        'checkbox-valor-hora-reuniao'
                      )}
                      label={''}
                      name='valorReuniaoEnabled'
                      onChange={this.setValue}
                      checked={
                        this.props.contratosAssessores.contratoEditing
                          .valorReuniaoEnabled
                      }
                      disabled={this.fieldDisabled()}
                    />
                  </div>
                  <div className={rootClassName + '-textfield-valor-hora'}>
                    <CustomCurrencyFieldValores
                      id={getElementID(rootElementId, 'valor-hora-reuniao')}
                      label={this.getValorHoraLabel(
                        this.props.languageValues
                          .agendaAssessorPedagogicoReuniaoType
                      )}
                      name='valorReuniao'
                      value={
                        this.props.contratosAssessores.contratoEditing
                          .valorReuniao
                      }
                      onChange={(value) => {
                        this.setValue({
                          target: {
                            name: 'valorReuniao',
                            value: value,
                          },
                        });
                      }}
                      error={
                        this.state.valorReuniaoChanged &&
                        !this.valorReuniaoIsValid().status
                      }
                      helperText={
                        this.state.valorReuniaoChanged &&
                          !this.valorReuniaoIsValid().status
                          ? this.valorReuniaoIsValid().error
                          : ''
                      }
                      disabled={
                        this.fieldDisabled() ||
                        !this.props.contratosAssessores.contratoEditing
                          .valorReuniaoEnabled
                      }
                    />
                    <InputAutomacaoNumber
                      id='valorReuniaoCentralizado'
                      valorAutomacao={this.state.valorReuniao}
                      onValorAutomacaoChange={(valor) =>
                        this.handleValorAutomacaoChange('valorReuniao', valor)
                      }
                    />
                  </div>
                </Col>
              </Row>
            </>
          )}
        </form>
      </GenericCardScreen>
    );
  }
}

DadosAssessor.propTypes = {
  editing: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  assessores: state.assessores,
  empresas: state.empresas,
  contratos: state.contratos,
  contratosAssessores: state.contratosAssessores,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeContratoAssessorEditingValue,
      clearEmpresaByCPFAssessor,
      loadAllEmpresas,
      loadEmpresaByCnpjComAcessoresNecessarios,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DadosAssessor));
